import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ThemeColors } from '@tryhackme/thm-ui-components/dist/config/theme/theme.types';
import styled from 'styled-components';

export const StyledTagsItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3rem;
  margin-bottom: 1.2rem;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 50%;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: unset;
  }
`;

export const StyledTagsItemText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledTagIcon = styled(FontAwesomeIcon)<{
  $color?: keyof Pick<ThemeColors, 'error' | 'success' | 'warning' | 'info'>;
}>`
  color: ${({ theme, $color }) => ($color ? theme.colors[$color].main : theme.colors.paragraph)};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
`;
